/** Consistent Live / Demo status badge class names. */

export function accountModeBadge(mode?: string | null, status?: string | null): string {
  const m = String(mode || '').toUpperCase()
  const s = String(status || '').toUpperCase()
  if (m === 'DEMO') return 'cp-badge cp-badge--demo'
  if (s.includes('PEND') || s === 'PENDING' || s === 'CREATING') return 'cp-badge cp-badge--pending'
  if (s === 'DISABLED' || s === 'INACTIVE' || s === 'CLOSED' || s === 'SUSPENDED') {
    return 'cp-badge cp-badge--disabled'
  }
  if (m === 'LIVE' || m === 'REAL') return 'cp-badge cp-badge--live'
  return 'cp-badge'
}
